import React, { ReactNode } from 'react';

import classNames from 'classnames';

import './icon-btn.scss';

interface IconBtnProps {
  icon?: string | ReactNode;
  title?: string;
  className?: string;
  sm?: boolean;
  rightIcon?: string;
  onClick?: () => void;
  outlined?: boolean;
  disabled?: boolean;
  loading?: boolean;
  lg?: boolean;
}

const IconBtn: React.FC<IconBtnProps> = ({
  icon,
  lg,
  outlined,
  disabled,
  title,
  rightIcon,
  onClick,
  sm,
  className = '',
  loading,
}) => (
  <button
    disabled={disabled}
    onClick={(e) => {
      e.preventDefault();
      if (onClick) {
        onClick();
      }
    }}
    type="button"
    className={classNames('btn', {
      'btn--sm': sm,
      'btn--lg': lg,
      'btn--outline': outlined,
      [className]: !!className,
    })}
  >
    {loading && (
      <svg
        version="1.1"
        className="svg-loader"
        x="0px"
        y="0px"
        width="40px"
        height="40px"
        viewBox="0 0 50 50"
      >
        <path
          fill="#000"
          d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
        >
          <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    )}
    {icon &&
      (typeof icon === 'string' ? (
        <img src={icon} className={`icon${loading ? ' hidden' : ''}`} alt="" />
      ) : (
        <span className={`icon${loading ? ' hidden' : ''}`}>{icon}</span>
      ))}
    {title && (
      <span className={`btn__text${loading ? ' hidden' : ''}`}>{title}</span>
    )}
    {rightIcon && (
      <img
        src={rightIcon}
        alt=""
        className={`icon ${loading ? 'hidden' : ''}`}
      />
    )}
  </button>
);

export default IconBtn;
